export default `
mutation ShiftReminders($shiftIds: [ID!]) {
  shiftReminders(shiftIds: $shiftIds) {
    createdAt
    updatedAt
    publishedAt
    acknowledgedAt
    updatedBy
    shiftId
    status
    createdBy
    userId
    isDeleted
    propertyId
    note
    startTime
    endTime
    serviceProviderId
    requests
    divisionId
    requiredLevels
    timezone
  }
}
`;